import { ToolPageShell } from '@/shared/seo'
import { ObedinitPdfForm } from './ObedinitPdfForm'

export function ObedinitPdfPage() {
  return (
    <ToolPageShell utilityKey="mergePdf">
      <ObedinitPdfForm />
    </ToolPageShell>
  )
}
